import { render, staticRenderFns } from "./TheUnitSideBar.vue?vue&type=template&id=1a594242&scoped=true&"
import script from "./TheUnitSideBar.vue?vue&type=script&lang=js&"
export * from "./TheUnitSideBar.vue?vue&type=script&lang=js&"
import style0 from "./TheUnitSideBar.vue?vue&type=style&index=0&id=1a594242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a594242",
  null
  
)

export default component.exports